import React from 'react'
import { type AlertColor, IconButton, Tooltip } from '@mui/material'
import AddToPhotosIcon from '@mui/icons-material/AddToPhotos'
import { isEmptyString } from '../../../utils/string-utils'
import { formatToLocalMilliTimestampFromUTCNumber } from '../../../utils/time-utils'
import { type IStrategyComponentRecord } from '../../../models/strategy/strategy-component-types'

export interface SaveSnapshotButtonProps {
  strategyId: string
  strategyDataRef: React.MutableRefObject<IStrategyComponentRecord>
  displayToastWithMessage: (message: string, severity: AlertColor) => void
}

export const exportData = (strategyId: string, strategyDataRef: React.MutableRefObject<IStrategyComponentRecord>): void => {
  if (isEmptyString(strategyId)) {
    console.debug('[Strategy] No strategy data found -- skipping export')
    return
  }

  const localStorageKey = `strategy-export-${strategyId}-${formatToLocalMilliTimestampFromUTCNumber(Date.now())}`
  console.log(`[Strategy] Exporting to local storage using key: ${localStorageKey}`)
  console.log('[Strategy] Current component map:')
  const strategyData = strategyDataRef.current
  console.log(strategyData)
  localStorage.setItem(localStorageKey, JSON.stringify(strategyData))
}

const SaveSnapshotButton: React.FC<SaveSnapshotButtonProps> = (props) => {
  const { strategyId, strategyDataRef, displayToastWithMessage } = props

  return (
    <Tooltip title='Save snapshot'>
      <IconButton
        size='small'
        onClick={() => {
          exportData(strategyId, strategyDataRef)
          displayToastWithMessage('Save complete', 'success')
        }}
      >
        <AddToPhotosIcon/>
      </IconButton>
    </Tooltip>
  )
}

export default React.memo(SaveSnapshotButton)
